import { ClockIcon } from '@heroicons/react/24/outline';

interface Props { allData: any[] }

export default function HearingDelayView(_props: Props) {
  return (
    <div className="flex-1 flex flex-col items-center justify-center gap-4 p-5">
      <div className="w-16 h-16 rounded-full border border-white/8 flex items-center justify-center" style={{ background: '#0a2e18' }}>
        <ClockIcon className="w-7 h-7 text-white/25" />
      </div>
      <div className="text-center">
        <h2 className="text-white/80 text-base font-semibold" style={{ fontFamily: 'var(--font-display)' }}>Case Delay Monitor</h2>
        <p className="text-white/30 text-xs mt-2 max-w-xs">Coming soon — this view is being reworked and isn&apos;t available yet.</p>
      </div>
    </div>
  );
}
